<template>
  <header>
    <h1>
      Timezone Friends
    </h1>
  </header>
</template>

<script>
export default {};
</script>

<style scoped>
header {
  margin-top: 30px;
  text-align: center;
  color: aliceblue;
  font-size: 1.5rem;
}

@media (max-width: 450px) {
  header {
    font-size: 1em;
  }
}
</style>
